import { Box, Container, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import notFound from '../../../images/404.svg'
import UseTranslation from '../../../hooks/UseTranslation'
import CookiesStorageService from '../../../services/CookiesStorageService'
import { selectAuthUser } from '../../../redux/features/userAuth/userAuthSlice'
import { isNotEmpty, objNotEmpty } from '../../../utils/helpers'
import { userAuthTokenDecode } from '../../../redux/features/userAuth/userAuthThunk'
import OfoqThemeBtn from '../../../components/Buttons/OfoqThemeBtn'

const NotFound = () => {
  const { t } = UseTranslation()
  const dispatch = useDispatch()
  const { authorizedUser } = useSelector(selectAuthUser)

  useEffect(() => {
    if (!objNotEmpty(authorizedUser) && isNotEmpty(CookiesStorageService.getAccessToken())) {
      dispatch(userAuthTokenDecode({ queries: { token: CookiesStorageService.getAccessToken() } }))
    }
  }, [])

  const isUserNotAuth = !objNotEmpty(authorizedUser)
  const umFrontEndPath = '/'
  const curHome = '/switch-modules'
  const redirectToAuthPage = () => {
    const url = isUserNotAuth ? umFrontEndPath : curHome;
    window.location.href = url;
  };

  return (
    <Box sx={styles.root}>
      <Container maxWidth='xl' sx={styles.container}>
        <Box sx={styles.textWrapper}>
          <Typography sx={styles.errorTitle} variant="h1">
            {t?.['Page not Found !']}
          </Typography>
          <Typography variant="h3" sx={styles.errorSubTitle}>
            {t?.['Sorry, but the page you’re looking for doesn’t exist.']}
          </Typography>
          <Typography variant="p" sx={styles.errorDescription}>
            {t?.
              ['It may have been moved, deleted, or never existed in the first place. You could move back to the Home Page or check the URL and try again.']}
          </Typography>
          <OfoqThemeBtn
          customStyle={styles.requestBtn}
          name={t?.['Move to Home Page']}
          onClick={redirectToAuthPage}
        />
        </Box>
        <Box component="img" src={notFound} sx={styles.image} />
      </Container>
    </Box>
  )
}

const styles = {
  root: {
    paddingTop: '-20px',
  },
  container: {
    paddingInline: '0px !important',
    display: 'flex',
    flexDirection: { xs: 'column-reverse', md: 'row' },
    justifyContent: { xs: 'center', md: 'space-between' },
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: { xs: 'center', md: 'flex-start' },
    padding: { xs: '20px 10px 0 10px', md: '150px 0 0 80px' },
  },
  errorTitle: {
    color: 'primary.main',
    fontSize: { xs: '20px', sm: '30px', md: '50px' },
    lineHeight: '19px',
  },
  errorSubTitle: {
    fontSize: { xs: '14px', sm: '18px', md: '22px' },
    lineHeight: '25px',
    paddingTop: { xs: '20px', md: '70px' },
  },
  errorDescription: {
    fontSize: { xs: '12px', sm: '16px', md: '18px' },
    lineHeight: { xs: '20px', sm: '25px' },
    paddingTop: { xs: '10px', md: '30px' },
    color: '#92929D',
    textAlign: { xs: 'center', sm: 'left' },
  },
  image: {
    maxWidth: { xs: '200px', sm: '581px' },
    maxHeight: { xs: '200px', sm: '70vh' },
    marginInline: 'auto',
  },
  requestBtn: {
    maxWidth: { xs: '200px', md: '318px' },
    marginTop: { xs: '30px', md: '30px' },
    color: 'white',
    marginInline: { xs: 'auto', md: '0' },
    px: { xs: 3, md: 5 },
    textTransform: 'none',
  },
}

export default NotFound
